import React from 'react';
import { Col, Row, Typography } from 'antd';
import Icon from '@ant-design/icons';

import { ButtonField, SelectField } from 'src/shared/components/form';
import TableCard from 'src/shared/components/table/Table';
import ModalForm from './ModalForm';
import useInit from './hooks/useInit';
import { PlusIcon } from 'src/assets/icons';
import { WrapperStyled } from './styled';

const { Title } = Typography;

const Labels: React.FC = () => {
  const {
    columns,
    dataSource,
    totalPageLabels,
    isLoading,
    isShowModal,
    labelSelected,
    currentPage,
    formik,
    dataSelectTerminals,
    terminalId,
    setIsShowModal,
    handleShowModal,
    fetchDataLabels,
    setCurrentPage,
    setTerminalId,
  } = useInit();

  const { getFieldProps, setFieldValue } = formik;

  return (
    <>
      <WrapperStyled className="labels-screen">
        <Col span={20} className="col-form">
          <Row className="row-btn">
            <Col span={8}>
              <Title level={4} className="title color-title-table-light-theme">
                利用デバイスグループ
              </Title>
            </Col>

            <Col span={16} className="col-left">
              <SelectField
                field={getFieldProps('terminalId')}
                optionsSelect={dataSelectTerminals}
                setFieldValue={setFieldValue}
                onChange={id => {
                  setTerminalId(id);
                  setCurrentPage(1);
                  void fetchDataLabels({ terminalId: id, page: 1 });
                }}
              />

              <ButtonField
                content={<Icon component={PlusIcon} />}
                type="primary"
                className="btn-create"
                onClick={() => handleShowModal(true, null)}
              />
            </Col>
          </Row>

          <Row className="row-table">
            <TableCard
              loading={isLoading}
              columns={columns}
              dataSource={dataSource}
              rowKey="id"
              totalPages={totalPageLabels}
              currentPage={currentPage}
              onChangePage={page => {
                setCurrentPage(page);
                void fetchDataLabels({ page });
              }}
            />
          </Row>
        </Col>
      </WrapperStyled>
      <ModalForm
        terminalSelects={dataSelectTerminals}
        labelSelected={labelSelected}
        isOpen={isShowModal}
        terminalId={terminalId}
        setIsShowModal={setIsShowModal}
      />
    </>
  );
};

export default Labels;
